import { useState } from 'react';
import { NavBarTest } from "../../../components/NavBarTest";
import Button from "@mui/material/Button";
import { FooterNew } from '../../../components/FooterNew';
import Stack from '@mui/material/Stack';
import ChevronRightIcon from "@mui/icons-material/ChevronRight";

const getUrl = window.location;
const baseUrl = getUrl.protocol + "//" + getUrl.host
export const MatchmakingTest = () => {
   document.title = "Venture Summit Digital Connect | Matchmaking";
   const [chevron, setChevron] = useState(0);
   const [margin1, setMargin1] = useState("0vw");

   return (
      <div>
         <NavBarTest />
         <div style={{ position: "relative" }}>
            <img alt='matchmaking'
               src={window.innerWidth < 769 ? "./assets/media/Group 141 (1).png" : "./assets/media/Group 139.png"}
               style={{ width: "100%", height: "auto", objectFit: "cover" }}
            />
            <div
               style={{
                  position: "absolute",
                  left: "50%",
                  bottom: window.innerWidth < 769 ? "50" : "10%",
                  transform: "translate(-50%,-50%)",
                  color: "white",
                  textAlign: "center",
                  gap: "25px",
                  display: window.innerWidth < 769 ? "none" : "flex",
                  flexDirection: "column",
               }}
            >
               <h1 style={{ fontSize: window.innerWidth < 769 ? "1rem" : "4rem", fontWeight: "400" }}>
                  MEET THE RIGHT PEOPLE
               </h1>
               <h4 style={{ width: "70%", margin: "auto" }}>
                  Venture Summit is the perfect place to efficiently meet, interact
                  and network One-on-One with your future investors and partners
                  utilizing an industry-leading built-in video meeting platform.
               </h4>
            </div>
         </div>

         <img alt='matchmaking'
            src={window.innerWidth < 769 ? "./assets/media/single-quote-testimonial-2-mobile.png" : "./assets/media/single-quote-testimonial-2.png"}
            style={{ width: "100%" }}
         />
         <div
            style={{
               display: "flex",
               width: "100%",
               justifyContent: "center",
               padding: "2.5%",
               backgroundColor: "#212529",
            }}
         >
            <div
               style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "2.5%",
                  width: "100%",
                  margin: "auto",
                  justifyContent: "center",
                  backgroundColor: "#212529",
                  flexDirection: window.innerWidth < 769 && "column",
                  color: "white",
               }}
            >
               <h1 style={{ fontWeight: "900", padding: '6%' }}>
                  BUILD <span style={{ color: "purple" }}>YOUR</span> NETWORK
               </h1>
               <Stack spacing={.25} style={{ fontSize: window.innerWidth < 800 ? "1rem" : "1.25rem", gap: '15px', margin: 'auto', textAlign: 'center' }}>
                  <div style={{ listStyleType: "inside !important" }}>
                     AI matchmaking
                  </div>
                  <div>Early Profile Setup</div>
                  <div>Schedule meetings in advance</div>
                  <div >
                     Hold meetings for up to two <br /> weeks after the summit
                  </div>
               </Stack>
            </div>
         </div>
         <img alt='matchmaking' src={window.innerWidth < 800 ? "./assets/media/Frame 183.png" : "./assets/media/Frame 176.png"} style={{ width: '100%' }} />
         <div
            style={{
               display: "flex",
               justifyContent: "center",
               padding: window.innerWidth < 800 ? "7%" : "3%",
               color: "white",
               backgroundColor: "#212529",
               width: "100%",
            }}
         >
            <h1 style={{ fontWeight: "900", fontSize: window.innerWidth < 769 ? "2rem" : "4rem", textAlign: "center" }}>
               How does it work?
            </h1>
         </div>
         <div style={{ display: "flex", flexDirection: "column", width: "100%" }}>
            {window.innerWidth < 800 ? <img alt='matchmaking' src={"./assets/media/Component 31 (1).png"} /> : <div
               style={{
                  display: "flex",
                  flex: 1,
                  padding: "3%",
                  alignItems: "center",
                  width: "100%",
               }}
            >
               <div
                  style={{
                     display: "flex",
                     flexDirection: "column",
                     gap: "1rem",
                     padding: "5%",
                     margin: "auto",
                     width: "100%",
                  }}
               >
                  <h1 style={{ color: "#7C2387", fontWeight: "900", fontSize: '3.5rem' }}>
                     Create your profile
                  </h1>
                  <div style={{ fontSize: '1.25rem' }}>
                     Setting up your profile is easy, and the app <br /> makes the
                     process as simple as possible.
                  </div>
                  <div style={{ fontSize: '1.25rem' }}>
                     Fill out your company profile, who you are, your <br />
                     industry, what you are looking for, and what you provide.
                  </div>
                  <div style={{ fontSize: '1.25rem' }}>
                     You can reach out to any attendee at the summit, <br />
                     but the your profile will dictate who your best matches are,
                     <br /> so set meetings with them!
                  </div>
               </div>
               <img alt='matchmaking'
                  src="./assets/media/35972757273_11a047846b_o 1.png"
                  style={{ width: "100%" }}
               />
            </div>}
            {window.innerWidth < 800 ? <img alt='matchmaking' src={"./assets/media/Component 32 (1).png"} /> : <div
               style={{
                  display: "flex",
                  flex: 1,
                  backgroundColor: "#212529",
                  padding: "3%",
                  alignItems: "center",
                  color: "white",
               }}
            >
               <img alt='matchmaking'
                  src="./assets/media/36384687760_b1bbb78587_o 3.png"
                  style={{ width: "100%" }}
               />
               <div
                  style={{
                     display: "flex",
                     flexDirection: "column",
                     gap: "1rem",
                     padding: "5%",
                     margin: "auto",
                     width: "100%",
                  }}
               >
                  <h1 style={{ color: "#7C2387", fontWeight: "900", fontSize: '3.5rem' }}>
                     Set your schedule
                  </h1>
                  <div style={{ fontSize: '1.25rem' }}>
                     We recommend blocking off as much time as <br /> possible during
                     the summit, to open yourself to <br />
                     as many opportunities as possible.
                  </div>
                  <div style={{ fontSize: '1.25rem' }}>
                     Check your schedule and decide the best times<br /> for you to meet.
                  </div>
                  <div style={{ fontSize: '1.25rem' }}>
                     The more flexible you can be, the more <br /> opportunity you’re opening yourself up to.
                  </div>
               </div>
            </div>}
            {window.innerWidth < 800 ? <img alt='matchmaking' src={"./assets/media/Component 33 (1).png"} /> : <div
               style={{
                  display: "flex",
                  flex: 1,
                  padding: "3%",
                  alignItems: "center",
               }}
            >
               <div
                  style={{
                     display: "flex",
                     flexDirection: "column",
                     gap: "1rem",
                     padding: "5%",
                     margin: "auto",
                     width: "100%",
                  }}
               >
                  <h1 style={{ color: "#7C2387", fontWeight: "900", fontSize: '3.5rem' }}>
                     Secure your meetings
                  </h1>
                  <div style={{ fontSize: '1.25rem' }}>
                     Your profile and business will be a factor on how <br /> many meetings requests you receive, but a <br /> bigger factor will be how engaged you are on the <br /> platform as well as the number of invites you <br /> send out.

                  </div>
                  <div style={{ fontSize: '1.25rem' }}>
                     Bear in mind that some attendees may be very <br /> busy, so it’s worthwhile reaching out to as many <br /> delegates that match your profile as possible.
                  </div>
                  <div style={{ fontSize: '1.25rem' }}>
                     Take your time to make the most of the Summit.
                  </div>
               </div>
               <img alt='matchmaking'
                  src="./assets/media/35972757273_11a047846b_o 1 (1).png"
                  style={{ width: "100%" }}
               />
            </div>}
            <div style={{ display: 'flex', justifyContent: 'center', backgroundColor: '#212529', padding: '5%' }}>
               <a href={`https://youngstartup.com/upcoming`} style={{ margin: 'auto' }}>
                  <Button
                     onMouseOver={(e) => {
                        setChevron(1);
                        setMargin1("1.5vw");
                     }}
                     onMouseLeave={() => {
                        setChevron(0);
                        setMargin1("0vw");
                     }}
                     className="dark-btn"
                     sx={{ fontWeight: "900", fontSize: '2rem', color: "white !important", backgroundColor: '#7C2387 !important', "&:hover": { backgroundColor: '#7C2387 !important', color: "white !important" } }}

                  >
                     <div style={{ display: "flex", alignItems: 'center' }}>
                        <ChevronRightIcon sx={{ opacity: "0" }} />
                        <div>Register Now</div>
                        <ChevronRightIcon
                           sx={{
                              transition: ".3s all ease-in-out",
                              opacity: chevron,
                              marginLeft: margin1,
                           }}
                        />
                     </div>
                  </Button>
               </a>
            </div>
         </div>
         <FooterNew />
      </div>
   );
};
